class DropdownSelect extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('[data-dropdown-trigger]');
    this.triggerLabel = this.querySelector('[data-dropdown-trigger-label]');
    this.list = this.querySelector('[data-dropdown-list]');
    this.select = this.querySelector('[data-dropdown-select]');
    this.options = Array.from(this.querySelectorAll('[data-dropdown-option]'));
  }

  connectedCallback() {
    this.trigger?.addEventListener('click', this.toggle);
    this.options.forEach((option) => {
      option.addEventListener('click', this.handleOptionClick);
      option.addEventListener('keydown', this.handleOptionKeydown);
    });
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.toggle);
    this.options.forEach((option) => {
      option.removeEventListener('click', this.handleOptionClick);
      option.removeEventListener('keydown', this.handleOptionKeydown);
    });
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  toggle = () => {
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  open() {
    if (!this.trigger || !this.list) return;

    this.trigger.setAttribute('aria-expanded', 'true');
    this.list.hidden = false;
  }

  close({ focusTrigger = false } = {}) {
    if (!this.trigger || !this.list) return;
    if (this.trigger.getAttribute('aria-expanded') !== 'true') return;

    this.trigger.setAttribute('aria-expanded', 'false');
    this.list.hidden = true;

    if (focusTrigger) {
      this.trigger.focus();
    }
  }

  selectOption(option) {
    if (!this.select) return;

    const value = option.dataset.value;
    const label = option.dataset.label ?? option.textContent.trim();

    this.options.forEach((o) => {
      o.setAttribute('aria-selected', o === option ? 'true' : 'false');
    });

    if (this.triggerLabel) this.triggerLabel.textContent = label;

    this.select.value = value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
    this.select.form?.requestSubmit();
  }

  handleOptionClick = (event) => {
    this.selectOption(event.currentTarget);
    this.close({ focusTrigger: true });
  };

  handleOptionKeydown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.selectOption(event.currentTarget);
      this.close({ focusTrigger: true });
    }
  };

  handleOutsideClick = (event) => {
    if (this.contains(event.target)) return;
    this.close();
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape') {
      this.close({ focusTrigger: true });
    }
  };
}

customElements.define('dropdown-select', DropdownSelect);
